import { PropsWithChildren } from 'react';

const BoldText = ({ children }: PropsWithChildren) => <span className="font-medium">{children}</span>;

export default BoldText;
